export const sortDatebySelection = (a: any, b: any) => {
    let priorityA: any
    let priorityB: any

    priorityA = !a ? a : new Date(a).getTime();
    priorityB = !b ? b : new Date(b).getTime();

    if (priorityA === priorityB) {
        return 0;
    }
    if (priorityB && !priorityA) {
        return -1
    }
    if (priorityA && !priorityB) {
        return 1
    }
    return (priorityA < priorityB) ? -1 : 1;
}


export const sortNumber = (a: any, b: any) => {
    let priorityA: any
    let priorityB: any
    const numberA: number = parseInt(a, 10)
    const numberB: number = parseInt(b, 10)

    priorityA = !numberA && numberA !== 0 ? -1 : numberA;
    priorityB = !numberB && numberB !== 0 ? -1 : numberB;

    if (priorityA === priorityB) {
        return 0;
    }
    return (priorityA < priorityB) ? -1 : 1;
}

export const sortCurrency = (a: any, b: any) => {
    let priorityA: any
    let priorityB: any

    const numberA: number = a !== "" ? parseFloat(a.replace(/[&\/\\#,+()$?<>{}]/g, '')) : 0;
    const numberB: number = b !== "" ? parseFloat(b.replace(/[&\/\\#,+()$?<>{}]/g, '')) : 0;

    priorityA = !numberA && numberA !== 0 ? -1 : numberA;
    priorityB = !numberB && numberB !== 0 ? -1 : numberB;

    if (priorityA === priorityB) {
        return 0;
    }
    return (priorityA < priorityB) ? -1 : 1;
}

export const sortString = (a:any, b:any) =>{
    let priorityA: any
    let priorityB: any

    const stringA: string = a !== "" && a !== null && a !== undefined ? a.replace(/[\/\\]/g, '').toLowerCase().trim() : "";
    const stringB: string = b !== "" && b !== null && b !== undefined ? b.replace(/[\/\\]/g, '').toLowerCase().trim() : "";

    priorityA = !stringA && stringA !== "" ? -1 : stringA;
    priorityB = !stringB && stringB !== "" ? -1 : stringB;

    if (priorityA === priorityB) {
        return 0;
    }
    return (priorityA < priorityB) ? -1 : 1;
}



// WEBPACK FOOTER //
// ./src/helpers/sortingHelper.ts